import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Navigation from '../components/Navigation';
import OakvaleLogo from '../components/OakvaleLogo';

export default function PendingApproval() {
  const { currentUser } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-green-50/30 to-emerald-50/30">
      <Navigation />
      
      <div className="min-h-[calc(100vh-4rem)] flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex justify-center">
            <OakvaleLogo />
          </div>
          <h2 className="mt-6 text-center text-3xl font-serif font-bold text-gray-900">
            Account Pending Approval
          </h2>
          <div className="mt-8 bg-white/80 backdrop-blur-sm py-8 px-4 shadow-soft sm:rounded-3xl sm:px-10 
            border border-gray-100/20">
            <div className="text-center space-y-4">
              <div className="flex justify-center">
                <div className="h-16 w-16 rounded-full bg-yellow-100 flex items-center justify-center">
                  <svg className="h-8 w-8 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>
              
              <p className="text-lg text-gray-900">
                Thank you for registering with Oakvale Credit Union!
              </p>
              
              <p className="text-sm text-gray-600">
                Your account is currently under review by our team. This process typically takes 1-2 business days.
                We will notify you via email ({currentUser?.email}) once your account has been approved.
              </p>

              <div className="mt-6 border-t border-gray-200 pt-6">
                <h3 className="text-sm font-medium text-gray-900">What happens next?</h3>
                <ul className="mt-4 text-left space-y-3">
                  <li className="flex items-start">
                    <div className="flex-shrink-0">
                      <svg className="h-5 w-5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <p className="ml-2 text-sm text-gray-600">
                      Our team will review your application and verify your information
                    </p>
                  </li>
                  <li className="flex items-start">
                    <div className="flex-shrink-0">
                      <svg className="h-5 w-5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <p className="ml-2 text-sm text-gray-600">
                      You will receive an email notification once your account is approved
                    </p>
                  </li>
                  <li className="flex items-start">
                    <div className="flex-shrink-0">
                      <svg className="h-5 w-5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <p className="ml-2 text-sm text-gray-600">
                      Once approved, you can log in and access all banking features
                    </p>
                  </li>
                </ul>
              </div>

              <div className="mt-6 border-t border-gray-200 pt-6">
                <p className="text-sm text-gray-600">
                  If you have any questions, please contact our support team at{' '}
                  <a href="mailto:support@oakvalecu.com" className="text-emerald-600 hover:text-emerald-500">
                    support@oakvalecu.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 